/**
 * Helper to keep Metadata information in order to expedite the access to common information.
 */
class MetadataTraverser {
    constructor(metadata) {
        this.aliasByUuid = new Map();
        this.uuidByAlias = new Map();
        this.metadata = metadata;
        this.process(metadata.getRoot());
    }
    process(node) {
        const { children, props } = node;
        const { alias, uuid } = props;
        if (alias && uuid) {
            this.aliasByUuid.set(uuid, alias);
            this.uuidByAlias.set(alias, uuid);
        }
        if (children) {
            children.forEach(child => {
                this.process(child);
            });
        }
    }
    /**
     * Provide the node alias by the uuid.
     *
     * @param uuid the node uuid.
     * @returns the node alias.
     */
    getAlias(uuid) {
        return this.aliasByUuid.get(uuid) || '';
    }
    /**
     * The node uuid by the alias.
     *
     * @param alias the node alias.
     * @returns the node alias or empty string.
     */
    getUuid(alias) {
        return this.uuidByAlias.get(alias) || '';
    }
    /**
     * Check if the node is childOf the informed parent.
     *
     * @param alias the node alias.
     * @param parentAlias the possible parent alias.
     * @returns if the node is childOf.
     */
    isChildOf(alias, parentAlias) {
        if (!alias)
            return false;
        const uuid = this.getUuid(alias);
        const parent = this.metadata.getParent(uuid);
        if (!parent)
            return false;
        const { props = { uuid: '' } } = this.metadata.getNode(parent) || {};
        const currenParentAlias = this.getAlias(props.uuid);
        const isChild = currenParentAlias === parentAlias;
        return isChild || this.isChildOf(currenParentAlias, parentAlias);
    }
}
export { MetadataTraverser, };
//# sourceMappingURL=metadata-traverser.js.map